import Choices from 'choices.js';

const selects = document.querySelectorAll('.e-choices');
const subDropdownItems = document.querySelectorAll('.m-data-attributes-mobile__sublist-item');

selects.forEach(function(select) {
    
    const el = new Choices(select, {
        allowHTML: true,
        shouldSort: false,    
        searchEnabled: false,
        searchChoices: false,
    });

    // Filter Mobile Data Characteristics
    el.passedElement.element.addEventListener(
        'choice',
        function(event) {
            filterMobileData(event.detail.choice.value);
        },
        false,
    );
});

function filterMobileData(value) {

    resetAllFilterData();

    if(value == 'all') {
        return;
    }

    var filter = 'filter-' + value;

    subDropdownItems.forEach(function(item){
        if(!item.classList.contains(filter)) {
            item.classList.add('hidden');
        }
    });
}

function resetAllFilterData() {
    subDropdownItems.forEach(function(item){
        if(item.classList.contains('hidden')) {
            item.classList.remove('hidden');
        }
    });
}

